// import React from 'react';

// const skillCategories = [
//   {
//     title: 'Frontend',
//     skills: [
//       { name: 'React', level: 90 },
//       { name: 'Html', level: 85 },
//       { name: 'Tailwind CSS', level: 90 },
//     ],
//   },
//   {
//     title: 'Backend',
//     skills: [
//       { name: 'Node.js', level: 85 },
//       { name: 'Express', level: 80 },
//       { name: 'Laravel', level: 75 },
//     ],
//   },
//   {
//     title: 'Tools & Others',
//     skills: [
//       { name: 'Git', level: 60 },
//       { name: 'PostgreSQL', level: 75 },
//       { name: 'MongoDB', level: 80 },
//     ],
//   },
// ];

// const Skills = () => {
//   return (
//     <section id='skills' className='py-20 bg-gray-50 dark:bg-gray-800'>
//       <div className='container mx-auto px-4'>
//         <h2 className='text-4xl font-bold text-center mb-16 bg-gradient-to-r from-blue-600 to-teal-400 bg-clip-text text-transparent'>
//           Technical Skills
//         </h2>

//         <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-8'>
//           {skillCategories.map((category, index) => (
//             <div
//               key={index}
//               className='bg-white dark:bg-gray-900 rounded-lg p-6 shadow-lg'
//             >
//               <h3 className='text-xl font-semibold mb-6'>{category.title}</h3>
//               <div className='space-y-4'>
//                 {category.skills.map((skill, skillIndex) => (
//                   <div key={skillIndex}>
//                     <div className='flex justify-between mb-1'>
//                       <span className='text-gray-700 dark:text-gray-300'>
//                         {skill.name}
//                       </span>
//                       <span className='text-gray-600 dark:text-gray-400'>
//                         {skill.level}%
//                       </span>
//                     </div>
//                     <div className='w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden'>
//                       <div
//                         className='h-full bg-gradient-to-r from-blue-600 to-teal-400 rounded-full transition-all duration-500'
//                         style={{ width: `${skill.level}%` }}
//                       />
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Skills;

import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faReact,
  faNodeJs,
  faPython,
  faPhp,
  faLaravel,
  faHtml5,
  faCss3Alt,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";

const toolsAndTech = [
  { name: "React Js", icon: faReact, color: "#61DBFB" },
  { name: "Node Js", icon: faNodeJs, color: "#68A063" },
  { name: "Python", icon: faPython, color: "#306998" },
  { name: "PHP", icon: faPhp, color: "#777BB4" },
  { name: "Laravel", icon: faLaravel, color: "#FF2D20" },
  { name: "HTML5", icon: faHtml5, color: "#E34F26" },
  { name: "CSS3", icon: faCss3Alt, color: "#264DE4" },
  { name: "GitHub", icon: faGithub, color: "#181717" },
];

// const checkerboardVariants = {
//   hidden: { opacity: 0, scale: 0.8 },
//   visible: { opacity: 1, scale: 1, transition: { duration: 6 } },
// };

const checkerboardVariants = {
  hidden: { opacity: 0, scale: 0.8, rotate: -180 },
  visible: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    transition: { duration: 1, ease: "easeOut" },
  },
};

const headerVariants = {
  hidden: { opacity: 0, scale: 0.8, x: 50 }, // Start offscreen to the right
  visible: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    x: 0, // Moves to its final position
    transition: { duration: 1, ease: "easeOut" },
  },
};
const Skills = () => {
  return (
    <section id="skills" className="py-20 bg-gray-50 dark:bg-gray-800">
      <div className="container mx-auto px-4">
        <motion.div
          variants={headerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.5 }}
        >
          <h2 className="text-4xl font-bold text-center mb-16 bg-gradient-to-r from-blue-600 to-teal-400 bg-clip-text text-transparent">
            Tools & Technologies
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 ">
          {toolsAndTech.map((tool, index) => (
            <motion.div
              key={index}
              className="bg-gray-200 dark:bg-gray-500 rounded-lg p-6 shadow-lg flex flex-col items-center"
              variants={checkerboardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ amount: 0.5 }}
            >
              <FontAwesomeIcon
                icon={tool.icon}
                size="3x"
                style={{ color: tool.color }}
                className="mb-4 text-gray-700 dark:text-gray-300"
              />
              <span className="text-gray-700 dark:text-gray-300 font-medium">
                {tool.name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
